import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as actionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const selectionList = (data) => {
  return {
    type: actionTypes.SELECTION_TYPE_OPTIONS,
    payload: data,
  };
};
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDisputeResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPUTE_DISPLAY_OBJ_SUMMARY,
  screenData: data,
});
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_SUMMARY,
  payload: data,
});
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
//  error msg dispatch function
export const dispatchErrorMsgDrugSummary = (data) => ({
  type: actionTypes.GET_ERROR_MSG_DRUG_SUMMARY,
  payload: data,
});
// error message for 5 sec for no data exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(dispatchErrorMsgDrugSummary([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgDrugSummary([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
// rebate programe dispatch function
export const dispatchRebateProgram = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_DRUG,
  dropdown: data,
});
//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};
// drug summary
export const dispatchCmsTypeSummary = (data) => ({
  type: actionTypes.GET_CMS_DRUG_TYPE_SUMMARY,
  payload: data,
});
export const dispatchDrugTypeSummary = (data) => ({
  type: actionTypes.GET_DRUG_TYPE_DRUG_SUMMARY,
  payload: data,
});
export const dispatchDrugCmsTypeSummary = (data) => ({
  type: actionTypes.GET_DRUG_CMS_TYPE_SUMMARY,
  payload: data,
});
export const dispatchFrom = (data) => ({
  type: actionTypes.GET_FROM,
  payload: data,
});

// rebate program Name dispatch function
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_SUMMARY,
  payload: data,
});
// get drug summary functiom
export const getCmsTypeSummary = (value) => (dispatch) => {
  dispatch(dispatchCmsTypeSummary([]));
  return axios
    .post(serviceEndPoint.DRUG_TYPE_GET_CMS_TYPE, value)
    .then((response) => {
      if (response.data.rebateCmsTypeVOList.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        return dispatch(dispatchCmsTypeSummary(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchCmsTypeSummary([]));
    });
};
export const getDrugTypeSummary = (value) => (dispatch) => {
  dispatch(dispatchDrugTypeSummary([]));
  return axios
    .post(serviceEndPoint.DRUG_TYPE_GET_DRUG_TYPE, value)
    .then((response) => {
      if (response.data.rebateDrugTypeVO.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchDrugTypeSummary(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchDrugTypeSummary([]));
    });
};

export const getDrugCmsTypeSummary = (value) => (dispatch) => {
  dispatch(dispatchDrugCmsTypeSummary([]));
  return axios
    .post(serviceEndPoint.DRUG_TYPE_GET_DRUG_CMS_TYPE, value)
    .then((response) => {
      if (response.data.rebateDrugCmsTypeVO.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchDrugCmsTypeSummary(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchDrugCmsTypeSummary([]));
    });
};
// refresh drug type
export const refreshDrugType = () => ({
  type: actionTypes.SET_REFRESH_DATA_DRUG,
  payload: {},
});
export const refreshDrugTypeDisplay = () => ({
  type: actionTypes.SET_REFRESH_DATA_DRUG_DISPLAY,
  payload: {},
});
// dispatch Display screen Object
export const dispatchDisplayObjSummary = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_SUMMARY,
  payload: data,
});
